import { createAction, props } from '@ngrx/store';
import { ResourceUri } from '@ngxp/rest';
import { VorgangResource } from '@schir-int-client/vorgang-shared';
import { VerfuegungListResource, VerfuegungResource } from './verfuegung.model';

const PREFIX = '[Verfuegung] ';

export const loadVerfuegungenByVorgangAction = createAction(PREFIX + 'Load Verfuegungen By Vorgang');

export const loadVerfuegungenByVorgangSuccessAction = createAction(
	PREFIX + 'Load Verfuegungen By Vorgang Success',
	props<{
		vorgang: VorgangResource;
		verfuegungen: VerfuegungListResource;
	}>()
);

export const createVerfuegungByVorgangAction = createAction(
	PREFIX + 'Create Verfuegung By Vorgang',
	props<{
		notiz: string;
	}>()
);

export const createVerfuegungByVorgangSuccessAction = createAction(
	PREFIX + 'Create Verfuegung By Vorgang Success',
	props<{
		vorgang: VorgangResource;
		verfuegung: VerfuegungResource;
	}>()
);

export const createKorrespondenzVerfuegungByVorgangAction = createAction(
	PREFIX + 'Create Korrespondenz Verfuegung By Vorgang',
	props<{
		notiz: string;
	}>()
);

export const createKorrespondenzVerfuegungByVorgangSuccessAction = createAction(
	PREFIX + 'Create Korrespondenz Verfuegung By Vorgang Success',
	props<{
		vorgang: VorgangResource;
		verfuegung: VerfuegungResource;
	}>()
);

export const loadVerfuegungAction = createAction(
	PREFIX + 'Load Verfuegung',
	props<{
		verfuegungUri: ResourceUri;
	}>()
);

export const loadVerfuegungSuccessAction = createAction(
	PREFIX + 'Load Verfuegung Success',
	props<{
		verfuegung: VerfuegungResource;
	}>()
);

export const setSelectedVerfuegungAction = createAction(
	PREFIX + 'Set Selected Verfuegung',
	props<{
		verfuegung: VerfuegungResource;
	}>()
);

export const markVerfuegungAsErledigtAction = createAction(
	PREFIX + 'Mark Verfuegung As Erledigt',
	props<{
		verfuegung: VerfuegungResource;
	}>()
);

export const markVerfuegungAsErledigtSuccessAction = createAction(PREFIX + 'Mark Verfuegung As Erledigt Success');

export const deleteVerfuegungAction = createAction(
	PREFIX + 'Delete Verfuegung',
	props<{
		verfuegung: VerfuegungResource;
	}>()
);

export const deleteVerfuegungSuccessAction = createAction(
	PREFIX + 'Delete Verfuegung Success',
	props<{
		verfuegungen: VerfuegungListResource;
		deleted: VerfuegungResource;
	}>()
);

export const deleteVerfuegungFailAction = createAction(
	PREFIX + 'Delete Verfuegung Fail',
	props<{
		error: any;
	}>()
);

export const updateVerfuegungNotizAction = createAction(
	PREFIX + 'Update Verfuegung Notiz',
	props<{
		notiz: string;
		verfuegungUri: ResourceUri;
	}>()
);

export const updateVerfuegungNotizSuccessAction = createAction(
	PREFIX + 'Update Verfuegung Notiz Success',
	props<{
		verfuegung: VerfuegungResource;
	}>()
);

export const createVerfuegungDruckAction = createAction(PREFIX + 'Create Verfuegung Druck');

export const createVerfuegungDruckSuccessAction = createAction(
	PREFIX + 'Create Verfuegung Druck Success',
	props<{
		file: Blob;
	}>()
);
